// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.moreContainer-WiFRLS{cursor:pointer;width:100%;height:40px;color:rgba(var(--coze-fg-3),var(--coze-fg-3-alpha));padding:10px 16px;display:flex;overflow:hidden}.moreContainer-WiFRLS .text-vl222g{text-align:left;color:rgba(var(--coze-fg-3),var(--coze-fg-3-alpha));font-size:14px;font-weight:500;line-height:20px}.moreContainer-WiFRLS:hover,.moreContainer-WiFRLS:hover .text-vl222g{color:rgba(var(--coze-brand-5),1)}.arrow-Nw6R63{position:relative;top:2px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"moreContainer": `moreContainer-WiFRLS`,
	"text": `text-vl222g`,
	"arrow": `arrow-Nw6R63`
};
export default ___CSS_LOADER_EXPORT___;
